<div class="chart-section" 	[ngClass]="{'on-print-chart-section': onPrint}"
>
	<!-- Daily In-Use Ah -->
	<h3 class="h4 mb-4">{{'studies.daily_operation_inuse_ah' | translate}}</h3>
	<sct-charts
		*ngIf="inUseAhData.length"
		[data]="inUseAhData"
		[columnNames]="inUseAhColumns"
		[options]="inUseAhOptions"
		[type]="'ColumnChart'"
		[height]="300"
		chartId="inUseAh"
		(ready)="onChartReady($event)"
	></sct-charts>
	<ng-container *ngTemplateOutlet="chartOrEmpty; context: { data: inUseAhData, id: 'inUseAh' }"></ng-container>

</div>

<!-- Daily UBU -->
<div class="chart-section" [ngClass]="{'on-print-chart-section': onPrint}">
	<h3 class="h4 mb-4">{{'studies.daily_operation_inuse_ubu' | translate}}</h3>
	<sct-charts
		*ngIf="ubuData.length"
		[data]="ubuData"
		[columnNames]="ubuColumns"
		[options]="ubuOptions"
		[type]="'ColumnChart'"
		[height]="300"
		chartId="ubu"
		(ready)="onChartReady($event)"
	></sct-charts>
	<ng-container *ngTemplateOutlet="chartOrEmpty; context: { data: ubuData, id: 'ubu' }"></ng-container>
</div>

<div class="chart-section" [ngClass]="{'on-print-chart-section': onPrint}">
	<h3 class="h4 mb-4">{{'studies.daily_operation_inuse_durations' | translate}}</h3>
	<sct-charts
		*ngIf="durationsData.length"
		[data]="durationsData"
		[columnNames]="durationsColumns"
		[options]="durationsOptions"
		[type]="'ColumnChart'"
		[height]="300"
		chartId="durations"
		(ready)="onChartReady($event)"
	></sct-charts>
	<ng-container *ngTemplateOutlet="chartOrEmpty; context: { data: durationsData, id: 'durations' }"></ng-container>
</div>


<div class="chart-section" [ngClass]="{'on-print-chart-section': onPrint}">
	<h3 class="h4 mb-4">{{'studies.daily_charge_opportunities' | translate}}</h3>
	<sct-charts
		*ngIf="chargeOppData.length"
		[data]="chargeOppData"
		[columnNames]="chargeOppColumns"
		[options]="chargeOppOptions"
		[type]="'ColumnChart'"
		[height]="300"
		chartId="chargeOpp"
		(ready)="onChartReady($event)"
	></sct-charts>
	<ng-container *ngTemplateOutlet="chartOrEmpty; context: { data: chargeOppData, id: 'chargeOpp' }"></ng-container>
</div>


<ng-template #chartOrEmpty let-data="data" let-id="id">
	<div class="mt-4 pl-3 pr-3" *ngIf="!data.length">
		<div class="alert alert-info">
			{{ 'g.no_data_to_show' | translate }}
		</div>
	</div>
</ng-template>